import { useApolloClient } from '@apollo/client'
import { useCallback, useEffect, useState } from 'react'
import { Worklog, WorklogOrderByInput, WorklogWhereInput } from '../../../generated/graphql'
import { WORKLOGS } from '../gql/verteOfficeGQL'
import { ACTIVE_WORKLOG_ORDER_BY, resolveActiveWorklog } from '../shared/resolveActiveWorklog'
import { WORKLOG_ID_KEY } from '../components/timeRecordModal'

interface WorklogOutputType {
  worklogs: Worklog[]
}

interface WorklogInputType {
  where: WorklogWhereInput
  orderBy: WorklogOrderByInput[]
}

export function useActiveWorklog(userId?: string) {
  const client = useApolloClient()
  const [activeWorklog, setActiveWorklog] = useState<Worklog | undefined>()
  const [loading, setLoading] = useState(false)

  const refresh = useCallback(async () => {
    setLoading(true)

    try {
      const resolved = await resolveActiveWorklog({
        userId,
        storedWorklogId: localStorage.getItem(WORKLOG_ID_KEY),
        fetchWorklogs: async (where) => {
          const result = await client.query<WorklogOutputType, WorklogInputType>({
            query: WORKLOGS,
            variables: {
              where,
              orderBy: ACTIVE_WORKLOG_ORDER_BY,
            },
            fetchPolicy: 'no-cache',
          })

          return result.data?.worklogs ?? []
        },
        setStoredWorklogId: (worklogId) => localStorage.setItem(WORKLOG_ID_KEY, worklogId),
        clearStoredWorklogId: () => localStorage.removeItem(WORKLOG_ID_KEY),
      })

      setActiveWorklog(resolved as Worklog | undefined)
    } catch (error) {
      console.error('Error resolving active worklog:', error)
      setActiveWorklog(undefined)
    } finally {
      setLoading(false)
    }
  }, [client, userId])

  useEffect(() => {
    void refresh()
  }, [refresh])

  return {
    activeWorklog,
    loading,
    refresh,
  }
}
